<div [appIsLoading]="loadingService.isLoading(this)">
    <div class="claim-filter-section content-page content-page-container content-wrap">
        <div [innerHtml]="contentPageDetails | sanitizeHtml"></div>
    </div>
</div>